import { string } from 'prop-types';

import { useForceUpdate } from '@lootboy/lib/hooks';
import { isFutureAndTruthy } from '@lootboy/lib/utils/dateAndTime';

import Countdown from './Countdown';

const AppropriateCountdown = ({ availableUntil, availableFrom }) => {
  const refresh = useForceUpdate();

  let date;
  let labelId;

  if (isFutureAndTruthy(availableFrom)) {
    date = availableFrom;
    labelId = 'LootDetailView_countdown_available_from';
  } else if (isFutureAndTruthy(availableUntil)) {
    date = availableUntil;
    labelId = 'LootDetailView_countdown_available_until';
  }

  if (!date) {
    return null;
  }

  return (
    <Countdown
      date={date}
      labelId={labelId}
      onEnd={refresh}
    />
  );
};

AppropriateCountdown.propTypes = {
  availableFrom: string,
  availableUntil: string,
};

export default AppropriateCountdown;
